import { motion } from 'framer-motion';
import { Github, Twitter, Mail, Heart } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-800 border-t border-dark-600/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold gradient-text">Shangbanlun</h3>
            <p className="text-gray-400 text-sm">
              个人博客 - 分享技术学习笔记，记录生活点滴
            </p>
            <div className="flex space-x-4">
              <a
                href="https://github.com/shangbanlun"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-cyan-400 transition-colors"
              >
                <Github size={20} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-cyan-400 transition-colors"
              >
                <Twitter size={20} />
              </a>
              <a
                href="mailto:contact@shangbanlun.com"
                className="text-gray-400 hover:text-cyan-400 transition-colors"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm">
                  首页
                </a>
              </li>
              <li>
                <a href="/posts" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm">
                  文章
                </a>
              </li>
              <li>
                <a href="/tech-news" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm">
                  科技资讯
                </a>
              </li>
              <li>
                <a href="/about" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm">
                  关于
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">联系方式</h4>
            <p className="text-gray-400 text-sm">
              如有问题或建议，欢迎通过邮件联系
            </p>
            <a
              href="mailto:contact@shangbanlun.com"
              className="text-cyan-400 hover:text-cyan-300 transition-colors text-sm"
            >
              contact@shangbanlun.com
            </a>
          </div>
        </div>

        {/* Copyright */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="mt-8 pt-8 border-t border-dark-600/50 flex flex-col md:flex-row items-center justify-between"
        >
          <p className="text-gray-500 text-sm">
            © {currentYear} Shangbanlun. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm flex items-center mt-2 md:mt-0">
            Made with <Heart size={14} className="mx-1 text-red-500" /> using React + Vite
          </p>
        </motion.div>
      </div>
    </footer>
  );
}